import Observer from "./Observer.vue";

export default Observer;



// WEBPACK FOOTER //
// ./src/components/observer/index.js